module.exports = __webpack_public_path__ + "img/help_content2.6ae1c3a6.png";